import React, { useState, useEffect } from "react";

const C = {
  bg: "#1a0f3a",
  bgCard: "#221550",
  text: "#e8dcc8",
  textMuted: "#7a6d8a",
  gold: "#c4973d",
  goldLight: "#dbb45a",
  border: "#3a2870",
  current: "#e85d4a",
};

const Royal = ({ zmanimList = [], title, showTitle = true, hebrewDate, countdown }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dayName = now.toLocaleDateString("he-IL", { weekday: "long" });
  const dateLabel = hebrewDate?.hebrewShort ? `${dayName} ${hebrewDate.hebrewShort}` : dayName;
  const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  return (
    <div style={{
      direction: "rtl", width: "100%", height: "100%",
      backgroundColor: C.bg, overflow: "hidden",
      display: "flex", flexDirection: "column",
      fontFamily: "inherit",
    }}>
      {showTitle && (
        <div style={{
          background: `linear-gradient(135deg, ${C.bgCard} 0%, ${C.bg} 100%)`,
          borderBottom: `3px double ${C.gold}`,
          padding: "1rem 1.5rem",
          display: "flex", flexDirection: "column", alignItems: "center", gap: "4px",
          flexShrink: 0, position: "relative",
        }}>
          <div style={{ position: "absolute", top: "4px", left: "4px", right: "4px", bottom: "4px", border: `1px solid ${C.gold}30`, pointerEvents: "none" }} />
          <span style={{ color: C.gold, fontWeight: 700, fontSize: "1.3em", letterSpacing: "2px" }}>{title}</span>
          <span style={{ color: C.text, fontSize: "0.85em", opacity: 0.8 }}>{dateLabel}</span>
          {countdown && (
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
              <span style={{ color: C.text, fontSize: "0.8em" }}>{countdown.label}</span>
              <span style={{ color: C.text, fontSize: "0.75em", opacity: 0.7 }}>{"\u05D1\u05E2\u05D5\u05D3"}</span>
              <span style={{ color: C.current, fontSize: "1em", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{countdown.remaining}</span>
            </div>
          )}
        </div>
      )}

      <div style={{ flex: 1, overflow: "auto", padding: "0.6rem 1rem", display: "flex", flexDirection: "column", gap: "4px" }}>
        {zmanimList.map((item) => {
          const toMinAdj = t => { const [h, m] = t.split(":").map(Number); return (h === 0 ? 24 : h) * 60 + m; };
          const isPast = toMinAdj(item.time) < toMinAdj(hhmm);
          const isCurrent = item.time === hhmm;
          return (
            <div key={item.key} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "0.5rem 0.8rem",
              opacity: isPast ? 0.65 : 1,
              backgroundColor: isCurrent ? `${C.current}18` : `${C.bgCard}80`,
              borderRadius: "8px",
              borderRight: `3px solid ${isCurrent ? C.current : C.gold}40`,
            }}>
              <span style={{
                color: isCurrent ? C.current : C.text,
                fontSize: "0.95em", fontWeight: isCurrent ? 700 : 500,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                flex: 1, minWidth: 0,
              }}>{item.label}</span>
              <span style={{
                color: isCurrent ? C.current : C.goldLight,
                fontSize: "1em", fontWeight: 700,
                fontVariantNumeric: "tabular-nums", flexShrink: 0, marginRight: "12px",
              }}>{item.time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Royal;
